module.exports = __webpack_public_path__ + "io-top-bw.svg?8e75eea47987f2366c7b0343a7ccb006";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/io-top-bw.svg
// module id = 77
// module chunks = 0